module.exports = __webpack_public_path__ + "static/media/fcc_logo_anime.d7d5e179.png";